import { FieldConfig } from "./field-config";

const location: {fields: FieldConfig[], customFields: FieldConfig[]} = {
    fields: [
        {
            name: "webSearchOnly",
            label: "Web Results Only",
            validators: {}
        },
        {
            name: "addressType",
            label: "",
            validators: {}
        },
        {
            name: "placeName",
            label: "Place Name",
            validators: {}
        },
        {
            name: "id",
            label: "",
            validators: {}
        },
        {
            name: "houseNumber",
            label: "Number",
            validators: {}
        },
        {
            name: "addressLine2",
            label: "Address Line 2",
            validators: {}
        },
        {
            name: "street",
            label: "Street",
            validators: {}
        },
        {
            name: "street1",
            label: "Street 1",
            validators: {}
        },
        {
            name: "street2",
            label: "Street 2",
            validators: {}
        },
        {
            name: "city",
            label: "City",
            validators: {}
        },
        {
            name: "county",
            label: "County",
            validators: {}
        },
        {
            name: "state",
            label: "State",
            validators: {}
        },
        {
            name: "zip",
            label: "Zip Code",
            validators: {}
        },
        {
            name: "latitude",
            label: "Latitude",
            validators: {}
        },
        {
            name: "longitude",
            label: "Longitude",
            validators: {}
        },
        {
            name: "unitTypeId",
            label: "Unit Type",
            validators: {}
        },
        {
            name: "unitType",
            label: "Unit Type",
            validators: {}
        },
        {
            name: "municipality",
            label: "Municipality",
            validators: {}
        },
        {
            name: "blockNumber",
            label: "Block Number",
            validators: {}
        },
        {
            name: "district",
            label: "District",
            validators: {}
        },
        {
            name: "mileMarker",
            label: "Mile Marker",
            validators: {}
        },
        {
            name: "uniqueIdentifier",
            label: "",
            validators: {}
        },
        {
            name: "commonLocationName",
            label: "Common Name",
            validators: {}
        }
    ],
    customFields: [],
  };

  export const locationMainFields = {
    fields: [...location.fields]
  }